import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import DocumentHead from 'legacyComponents/documentHead';
import { Link } from 'core/routing';
import { analytics } from 'core/analytics';

import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { SmallProfileCard } from 'legacyComponents/cards/types/profileSmall';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { StoryCard } from 'legacyComponents/cards/types/story';
import { ThreadCard } from 'legacyComponents/cards/types/thread';

import { clientStore } from 'apps/client/app';
import { ButtonsWrapper } from 'apps/repository/styles';
import { Button } from 'components';
import { InitiativeOverviewManager } from 'apps/initiative/tabs/overview/appManager';

@withNamespaces()
@observer
export class InitiativeOverviewTab extends React.Component {
  UNSAFE_componentWillMount() {
    analytics.sendEvent('ViewContent', {}, { twitter: true, facebook: true });
    analytics.linkedinPixel('1169129');
    this.appManager = new InitiativeOverviewManager(
      this.props.initiativeManager,
      this.props,
    );
  }

  render() {
    const { initiativeManager, params } = this.props;
    const { initiative } = initiativeManager;
    const {
      title,
      projectsCount,
      storiesCount,
      threadsCount,
      canUpdate,
      inSpace: { whichTypes },
    } = initiative;

    const {
      membersConn,
      projectsConn,
      storiesConn,
      threadsConn,
    } = this.appManager;

    const initiativeParams = { initiative: params.get('initiative') };

    const ProjectsButton = projectsCount > 3 && (
      <ButtonsWrapper>
        <Link name='initiative.projects' params={initiativeParams}>
          <Button text={<Trans>All Projects</Trans>} size='small' />
        </Link>
      </ButtonsWrapper>
    );

    const StoriesButton = storiesCount > 2 && (
      <ButtonsWrapper>
        <Link name='initiative.stories' params={initiativeParams}>
          <Button text={<Trans>All Stories</Trans>} size='small' />
        </Link>
      </ButtonsWrapper>
    );

    const ForumButton = threadsCount > 0 && (
      <ButtonsWrapper>
        <Link name='initiative.forum' params={initiativeParams}>
          <Button text={<Trans>Go to Forum</Trans>} size='small' />
        </Link>
      </ButtonsWrapper>
    );
    return (
      <MainWrapper>
        <DocumentHead title={`${title} - Overview`} />
        <CardSection
          title='People'
          tooltip='Add people'
          createHandler={
            whichTypes.includes('GroupMember')
              ? () =>
                  clientStore.routerStore.navigate(
                    'workspace.spaceSettings.teams',
                    { spacePath: initiativeParams.initiative },
                  )
              : ''
          }
          owner={canUpdate}
          ownerName={title}
          cardApp={membersConn.arrayApp}
          CardComponent={SmallProfileCard}
          noDataCardType='profile'
          last={projectsCount === 0 && storiesCount === 0 && threadsCount === 0}
          gridColumns={3}
          gridGap='default'
          intercomTarget='organisation-people'
        />
        {projectsCount === 0 ? (
          <React.Fragment />
        ) : (
          <CardSection
            title='Recent Projects'
            tooltip='Create new project'
            createHandler={
              whichTypes.includes('Space')
                ? () => clientStore.routerStore.navigate('home.newProject')
                : ''
            }
            owner={canUpdate}
            ownerName={title}
            cardApp={projectsConn.arrayApp}
            CardComponent={ProjectCard}
            last={storiesCount === 0 && threadsCount === 0}
            noCount
            actions={ProjectsButton}
            gridColumns={3}
          />
        )}
        {storiesCount === 0 ? (
          <React.Fragment />
        ) : (
          <CardSection
            title='Recent Stories'
            tooltip='Create new story'
            createHandler={
              whichTypes.includes('Story')
                ? () => clientStore.routerStore.navigate('home.newStory')
                : ''
            }
            owner={canUpdate}
            ownerName={title}
            cardApp={storiesConn.arrayApp}
            CardComponent={StoryCard}
            last={threadsCount === 0}
            noCount
            actions={StoriesButton}
            gridColumns={2}
          />
        )}
        {threadsCount === 0 ? (
          <React.Fragment />
        ) : (
          <CardSection
            title='Recent Threads'
            owner={canUpdate}
            ownerName={title}
            cardApp={threadsConn.arrayApp}
            CardComponent={ThreadCard}
            last
            noCount
            actions={ForumButton}
          />
        )}
      </MainWrapper>
    );
  }
}

InitiativeOverviewTab.propTypes = {
  initiativeManager: PropTypes.object,
  params: PropTypes.object,
  routeName: PropTypes.string,
  t: PropTypes.func,
};
